import { render, staticRenderFns } from "./FathomPageDetailBlock.vue?vue&type=template&id=9662b8fc&scoped=true"
import script from "./FathomPageDetailBlock.vue?vue&type=script&lang=js"
export * from "./FathomPageDetailBlock.vue?vue&type=script&lang=js"
import style0 from "./FathomPageDetailBlock.vue?vue&type=style&index=0&id=9662b8fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9662b8fc",
  null
  
)

export default component.exports